import { Button, Switch, TextField } from '@material-ui/core';
import React, { useState } from 'react';

import { DateTimePickerCustom } from '~/src/dash/components/datepicker/datetimepicker-custom';
import PillSwitcher from '~/src/dash/components/pill-switcher';
import { Col, Cols, Row, Rows, spacing, Text, TextButton } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { isValidEmail } from '~/src/dash/utils/email';
import { IProps } from '~/src/dash/views/ias-publisher/IASReportBuilder/Report/common/types';
import { SingleSelect } from '~/src/dash/views/singleselect-view';

const recipientError = (recipient: string, recipients: string[]) => {
  const v = recipient.trim();
  if (!isValidEmail(v)) {
    return 'Email is not valid.';
  }
  if (recipients.indexOf(v) > -1) {
    return 'Email already in the list.';
  }
  return '';
};

export const ScheduleRow = (props: IProps) => {
  const [email, setEmail] = useState<string>('');
  const [showErr, setShowErr] = useState(false);

  const addEmail = () => {
    if (!recipientError(email, props.recipients)) {
      setShowErr(false);
      setEmail('');
      props.handleAddRecipients(email);
    } else {
      setShowErr(true);
    }
  };

  return (
    <Rows>
      <Row noHorizontalPadding smallVerticalPadding>
        <Cols style={{ alignItems: 'center' }}>
          <Col style={{ width: '140px' }}>
            <Text small bold>
              {' '}
              Status
            </Text>
          </Col>
          <Col>
            <Switch checked={props.scheduleEnabled} onChange={props.handleChangeScheduleEnabled} />
          </Col>
          <Col smallHorizontalPadding>
            <Text small>{props.scheduleEnabled ? 'Active' : 'Inactive'}</Text>
          </Col>
        </Cols>
      </Row>
      <Row noHorizontalPadding smallVerticalPadding>
        <Cols style={{ alignItems: 'center' }}>
          <Col style={{ width: '140px' }} paddingTop={spacing.medium}>
            <Text small bold>
              {' '}
              Frequency
            </Text>
          </Col>
          <Col smallHorizontalPadding>
            <SingleSelect
              name={'Frequency'}
              items={props.reportFrequencies}
              value={props.reportFrequency}
              label={''}
              onChange={props.handleChangeReportFrequency}
              style={{
                width: '200px',
                height: '35px',
                border: `1px solid ${publicaColors.lightGray}`,
                borderRadius: '5px',
                fontSize: '14px',
                minWidth: '120px',
                paddingLeft: '2px',
              }}
            />
          </Col>
          <Col paddingLeft={spacing.extraLarge} paddingTop={spacing.medium}>
            <Text small bold>
              Run On
            </Text>
          </Col>
          <Col largeHorizontalPadding>
            <DateTimePickerCustom
              placeholder={''}
              type={'start'}
              date={props.runOnDate}
              handleDateChange={props.handleChangeRunOnDate}
              disableTime
              smallCalendar
            />
          </Col>
        </Cols>
      </Row>
      <Row noHorizontalPadding smallVerticalPadding>
        <Cols style={{ alignItems: 'center' }}>
          <Col style={{ width: '140px' }}>
            <Text small bold>
              {' '}
              Delivery
            </Text>
          </Col>
          <Col smallHorizontalPadding paddingTop={spacing.medium}>
            <PillSwitcher
              currentText={props.deliveryType}
              pills={props.deliveryTypeList}
              onChange={(value: string) => props.handleChangeReportDeliveryType(value)}
            />
          </Col>
        </Cols>
      </Row>
      <Row noHorizontalPadding smallVerticalPadding>
        <Cols style={{ alignItems: 'center' }}>
          <Col style={{ width: '140px' }}>
            <Text small bold>
              {' '}
              Recipients
            </Text>
          </Col>
          <Col smallHorizontalPadding paddingTop='4px'>
            <TextField
              name='Email Recipients'
              placeholder={'Enter email addresses, comma seperated'}
              helperText={showErr && recipientError(email, props.recipients)}
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              style={{
                width: '400px',
                border: `1px solid ${publicaColors.lightGray}`,
                borderRadius: '5px',
                paddingLeft: '2px',
                fontSize: '12px',
              }}
              onKeyUp={(ev: React.KeyboardEvent) => {
                if (ev.key === 'Enter') {
                  addEmail();
                }
              }}
              error={showErr}
            />
          </Col>
          <Col smallPadding>
            <TextButton onClick={addEmail} style={{ fontSize: '14px' }}>
              + Add Recipient
            </TextButton>
          </Col>
        </Cols>
      </Row>
      <Row hugeHorizontalPadding>
        <Rows hugeHorizontalPadding>
          {props.recipients.map((email, index) => (
            <Row
              noPadding
              style={{
                alignItems: 'center',
                margin: '0 0 8px 18px',
                width: 'fit-content',
                backgroundColor: 'rgb(248, 250, 255)',
              }}
            >
              <Cols>
                <Col paddingLeft='8px'>
                  <Text small muted>
                    {email}
                  </Text>
                </Col>
                <Col>
                  <Button onClick={() => props.handleRemoveRecipients(index)}>
                    <img src='/assets/shared/svg/publisherPlatform/Close.svg' />
                  </Button>
                </Col>
              </Cols>
            </Row>
          ))}
        </Rows>
      </Row>
    </Rows>
  );
};
